(function () {
  'use strict';

  var DIALOG_SELECTOR = '[role="dialog"][aria-modal="true"]';

  function isVendorDialog(el) {
    if (!el) return false;
    if (el.className && String(el.className).indexOf('kl-private-reset-css') !== -1) return true;
    if ((el.getAttribute('aria-label') || '').toLowerCase().indexOf('popup form') !== -1) return true;
    return Boolean(el.closest('.klaviyo-form, [class*="kl-private"]'));
  }

  function findVendorDialog() {
    var candidates = document.querySelectorAll(DIALOG_SELECTOR);
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (isVendorDialog(el) && el.getBoundingClientRect().width > 0) return el;
    }
    return null;
  }

  function fallbackTarget() {
    var el =
      document.getElementById('main-content') ||
      document.querySelector('main.main-content') ||
      document.querySelector('main[role="main"]');
    if (!el) return null;
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    return el;
  }

  function start() {
    var lastFocused = null;
    var dialogWasOpen = false;

    function onFocusIn(event) {
      var target = event.target;
      if (!target || target.nodeType !== 1) return;

      var enclosing = target.closest(DIALOG_SELECTOR);
      if (enclosing && isVendorDialog(enclosing)) return;

      if (dialogWasOpen) return;
      lastFocused = target;
    }

    function restoreFocus() {
      var target =
        lastFocused && document.contains(lastFocused) ? lastFocused : fallbackTarget();
      if (!target) return;

      requestAnimationFrame(function () {
        if (
          document.activeElement &&
          document.activeElement !== document.body &&
          document.activeElement !== document.documentElement
        ) {
          return;
        }
        target.focus();
      });
    }

    function checkDialog() {
      var isOpen = Boolean(findVendorDialog());
      if (isOpen && !dialogWasOpen) {
        dialogWasOpen = true;
      } else if (!isOpen && dialogWasOpen) {
        dialogWasOpen = false;
        restoreFocus();
      }
    }

    document.addEventListener('focusin', onFocusIn, true);

    if (typeof MutationObserver === 'function') {
      new MutationObserver(checkDialog).observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class', 'hidden', 'role', 'aria-modal'],
      });
    }

    checkDialog();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
